export default {
  max: {
    en: 'max',
  },
}
